module.exports = __webpack_public_path__ + "static/media/connector_icon_data-factory.76af6a3f.svg";